export default () => ({
  chipContainer: { marginTop: 10 },
  paper: {
    maxHeight: '250px',
    width: '100%',
    backgroundColor: 'white',
    zIndex: 2,
    overflow: 'auto',
  },
  inputRoot: { flexWrap: 'wrap' },
  inputInput: {
    width: 'auto',
    flexGrow: 1,
  },
  inputAdornmentIcon: {
    marginBottom: 4,
    marginRight: 12,
  },
});
